import { render, staticRenderFns } from "./CanvasEditorContainer.vue?vue&type=template&id=7544ea3b&scoped=true&"
import script from "./CanvasEditorContainer.vue?vue&type=script&lang=js&"
export * from "./CanvasEditorContainer.vue?vue&type=script&lang=js&"
import style0 from "./CanvasEditorContainer.vue?vue&type=style&index=0&id=7544ea3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7544ea3b",
  null
  
)

export default component.exports